import Service from 'react-reservice';

import { EMainProductCodeType, ICompany, IContact } from '@aqx-core/common/api/config';

import { EAppType } from './types';

export interface ICompanyServiceContext {
  loading: boolean;
  companyProfile?: ICompany | null;
  companyContact?: IContact | null;
  mainProductCode?: EMainProductCodeType;
  isLangInitialised?: boolean;
  appType?: EAppType;
}

const defaultContext: ICompanyServiceContext = {
  loading: true,
  isLangInitialised: false
};

class CompanyService extends Service<ICompanyServiceContext> {
  constructor() {
    super();

    this.context = defaultContext;
  }

  getCompanyTenantId = () => {
    return this.context.companyProfile?.tenantId;
  };

  getCompanyIntegration = () => {
    return this.context.companyProfile?.currentMainProductCode || this.context.companyProfile?.mainProductCodeList[0];
  };

  setLoading = (loading: boolean) => {
    this.context.loading = loading;
  };

  setCompanyProfile = (nextCompanyProfile?: ICompany | null) => {
    this.context.companyProfile = nextCompanyProfile;
  };

  setCompanyContact = (nextCompanyContact: IContact | null | undefined) => {
    this.context.companyContact = nextCompanyContact;
  };

  setMainProductCode = (nextMainProductCode: EMainProductCodeType) => {
    this.context.mainProductCode = nextMainProductCode;
  };

  setIsLangInitialised = (isLangInitialised: boolean) => {
    this.context.isLangInitialised = isLangInitialised;
  };

  setAppType = (appType: EAppType) => {
    this.context.appType = appType;
  };
}

export const companyService = new CompanyService();
